// import utils from "@/eco-ui-util.js";
import req from "@/request.js";
// const portal = req.getContext().portal;
// const uc = req.getContext().uc;
// const business = req.getContext().business;
const work = req.getContext().work;

export default {
  // 获取模板库列表
  getPublicTemplate(params,val) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/project_manager_planning_template/query_public_list?proType=${val}`,
          method: "GET",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取我的模板列表
  getMySelfTemplate(params,val) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/project_manager_planning_template/query_self_template_list?proType=${val}`,
          method: "GET",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  
  // 获取我的模板下子级
  getmpTemplateDetail(params) {
    return new Promise((resolve, reject) => {
      req
        .get(`${work}/planning/project_manager_planning_template_detail/query_self_by_template_id/${params}`)
        .then(
          response => {
            resolve(response.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取模板库下子级
  getmpPublicTemplateDetail(params) {
    return new Promise((resolve, reject) => {
      req.get(`${work}/planning/project_manager_planning_template_detail/query_public_by_template_id/${params}`)
        .then(
          response => {
            resolve(response.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 删除模板
  delManagerPlanTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/project_manager_planning_template/${params}`,
          method: "DELETE",
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 删除任务
  delManagerPlanTemplateDetail(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/project_manager_planning_template_detail/${params}`,
          method: "DELETE",
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },






};
